import { isObject } from '@repo/utils/type.utils';

export interface Printer {
    name: string;
    serverName: string;
}
export interface GetPrinterResponse {
    printers: {
        empuPrinters: Printer[];
        pTagPrinters: Printer[];
        regularPrinters: Printer[];
        smartPrinters: Printer[];
    };
}

export interface DefaultPrinter {
    defaultPrinter: Printer;
}

interface FavouritePrinterListResponse {
    favoritePrinters: Printer[];
}

export function isGetPrinterResponse(value: unknown): value is GetPrinterResponse {
    return isObject(value) && 'printers' in value;
}

export function isFavouritePrinterListResponse(value: unknown): value is FavouritePrinterListResponse {
    return isObject(value) && 'favoritePrinters' in value && Array.isArray(value.favoritePrinters);
}

export function isDefaultPrinter(value: unknown): value is DefaultPrinter {
    return isObject(value) && 'defaultPrinter' in value;
}
